import { QuiltedHealthCodeSystems } from "@/fhir/enums/quilted-health";

/**
 * Builds a FHIR DocumentReference `type` search clause for the given uploaded-document type codes.
 * Returns an empty object when no types are provided so callers can spread it into a query safely.
 */
export function buildFileTypesFilter(fileTypes: string[]) {
  if (fileTypes.length === 0) return {};

  return {
    type: fileTypes
      .map((type) => `${QuiltedHealthCodeSystems.UploadedDocumentTypes}|${type}`)
      .join(","),
  };
}
